// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green {
  color: green;
}

.red {
  color: red;
}

.CostDetails__BudgetPanel {
  display: block;
  width: 100%;
}
.CostDetails__Form {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.CostDetails__Form .input-class {
  flex: 1 1 20rem;
  min-width: 20rem;
}
.CostDetails__Values {
  font-size: 1.4rem;
  font-weight: bold;
}

ion-col.ion-align-items-start {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/property-details/components/cost-details/cost-details.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAGE;EACE,cAAA;EACA,WAAA;AAAJ;AAEE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;AAAN;AAIE;EACE,iBAAA;EACA,iBAAA;AAFJ;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAJF","sourcesContent":[".green {\n  color: green;\n}\n\n.red {\n  color: red;\n}\n\n.CostDetails {\n  &__BudgetPanel {\n    display: block;\n    width: 100%;\n  }\n  &__Form {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n\n    .input-class {\n      flex: 1 1 20rem;\n      min-width: 20rem;\n    }\n  }\n\n  &__Values {\n    font-size: 1.4rem;\n    font-weight: bold;\n  }\n}\n\n// Add flexbox styles for migrated columns\nion-col.ion-align-items-start {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
